import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ExperiencePerformanceTypes, ExperienceTypes, UFOExperience, UFOExperienceState } from '@atlaskit/ufo';
import { ExperienceCheckComposite } from './ExperienceCheckComposite';
var PROGRESS_STATES = [UFOExperienceState.STARTED.id, UFOExperienceState.IN_PROGRESS.id];
export var Experience = /*#__PURE__*/function () {
  function Experience(id) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, Experience);
    this.id = id;
    this.options = options;
    this.check = new ExperienceCheckComposite(this.options.checks || []);
  }
  return _createClass(Experience, [{
    key: "ufoExperience",
    get: function get() {
      if (!this._ufoExperience) {
        this._ufoExperience = new UFOExperience(this.id, {
          type: ExperienceTypes.Experience,
          performanceType: ExperiencePerformanceTypes.InlineResult,
          platform: {
            component: 'editor'
          }
        });
      }
      return this._ufoExperience;
    }
  }, {
    key: "startCheck",
    value: function startCheck() {
      var _this = this;
      this.stopCheck();
      this.check.start(function (result) {
        var metadata = result.metadata;
        if (result.status === 'success') {
          _this.success({
            metadata: metadata
          });
        } else if (result.status === 'abort') {
          _this.abort({
            metadata: metadata
          });
        } else if (result.status === 'failure') {
          _this.failure({
            metadata: metadata
          });
        }
      });
    }
  }, {
    key: "stopCheck",
    value: function stopCheck() {
      this.check.stop();
    }
  }, {
    key: "isInProgress",
    value: function isInProgress() {
      return PROGRESS_STATES.includes(this.ufoExperience.state.id);
    }
  }, {
    key: "getEndStateConfig",
    value: function getEndStateConfig(options) {
      var _this$startOptions, _this$startOptions2;
      return {
        metadata: options !== null && options !== void 0 && options.metadata || (_this$startOptions = this.startOptions) !== null && _this$startOptions !== void 0 && _this$startOptions.metadata ? _objectSpread(_objectSpread({}, (_this$startOptions2 = this.startOptions) === null || _this$startOptions2 === void 0 ? void 0 : _this$startOptions2.metadata), options === null || options === void 0 ? void 0 : options.metadata) : undefined
      };
    }

    /**
     * Starts tracking the experience and all checks which monitor for completion.
     *
     * If the experience is already in progress, this will restart the checks.
     * Metadata from options will be merged with any end state metadata.
     *
     * @param options - Configuration for starting the experience
     * @param options.metadata - Optional metadata attached to all subsequent events for this started experience
     */
  }, {
    key: "start",
    value: function start(options) {
      this.startOptions = options;
      this.ufoExperience.start();
      if (this.isInProgress()) {
        this.startCheck();
      }
    }

    /**
     * Marks the experience as successful and stops any ongoing checks.
     *
     * Use this when the experience completes as expected.
     *
     * @param options - Configuration for the success event
     * @param options.metadata - Optional metadata attached to the success event
     */
  }, {
    key: "success",
    value: function success(options) {
      this.stopCheck();
      this.ufoExperience.success(this.getEndStateConfig(options));
      this.startOptions = undefined;
    }

    /**
     * Aborts the experience and stops any ongoing checks.
     *
     * Use this when a started experience terminates early due to user action or context change
     * (e.g., component unmount, navigation). This is neither success nor failure.
     *
     * @param options - Configuration for the abort event
     * @param options.metadata - Optional metadata attached to the abort event
     *
     * @example
     * // Abort on component unmount
     * useEffect(() => {
     *   return () => experience.abort({ metadata: { reason: 'unmount' } });
     * }, []);
     */
  }, {
    key: "abort",
    value: function abort(options) {
      this.stopCheck();
      this.ufoExperience.abort(this.getEndStateConfig(options));
      this.startOptions = undefined;
    }

    /**
     * Manually marks the experience as failed and stops any ongoing checks.
     *
     * Use this for actual failures in the experience flow (e.g., timeout, error conditions).
     *
     * @param options - Configuration for the failure event
     * @param options.metadata - Optional metadata attached to the failure event
     */
  }, {
    key: "failure",
    value: function failure(options) {
      this.stopCheck();
      this.ufoExperience.failure(this.getEndStateConfig(options));
      this.startOptions = undefined;
    }
  }]);
}();